import { Entity, MicroMClient } from "@mcurros2/microm";
import { DatosServiciosAutorizacionProductosFiltersDef } from "./DatosServiciosAutorizacionProductosFiltersDef";


export class DatosServiciosAutorizacionProductosFilters extends Entity<DatosServiciosAutorizacionProductosFiltersDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new DatosServiciosAutorizacionProductosFiltersDef(), parentKeys);
        this.Form = import('./DatosServiciosAutorizacionProductosFiltersForm').then((module) => module.DatosServiciosAutorizacionProductosFiltersForms);
        this.Title = "Filtros de Datos Servicios";
    }
}